import _jsx from "@babel/runtime/helpers/jsx";
var _div;
import PropTypes from 'prop-types';
import React, { PureComponent, createRef } from 'react';
import { BrowserStorage } from '@atc/browser-storage';
import { PopoverSheet } from 'reaxl';
import _isEmpty from 'lodash/isEmpty';
import { WalletHeaderBadge, WalletHeaderPopover } from 'reaxl-wallet';
import clsx from 'clsx';
import { headerBadge as myatcNavItems } from 'axl-config';
import HeaderBadgeSlidingMenu from '../HeaderBadgeSlidingMenu';
import HeaderBadgeTrigger from '../HeaderBadgeTrigger';
import { PopoverHeader } from './PopoverHeader';
class HeaderBadge extends PureComponent {
  constructor() {
    super(...arguments);
    // for WalletHeaderPopover
    this.triggerDealReminder = () => {
      // check that deal(s) is/are older than 24 hours
      const oneDay = 24 * 60 * 60 * 1000;
      const today = Date.now();
      if (Object.keys(this.props.dealDetails)?.length) {
        const {
          dealDetails
        } = this.props;

        // checks that the user has not already been reminded to schedule test drive or submit credit app
        return Object.keys(dealDetails).some(dealId => (!dealDetails[dealId]?.testDrive?.testDriveNotified || !dealDetails[dealId]?.creditApp?.creditAppNotified && dealDetails[dealId]?.creditApp?.creditAppSubmittedFlag === false) && today - Date.parse(dealDetails[dealId].createdDate) > oneDay);
      }
      return false;
    };
    this.triggerRef = /*#__PURE__*/createRef();
    this.handleSignInClick = this.handleSignInClick.bind(this);
    this.handlePopoverOpen = this.handlePopoverOpen.bind(this);
    this.handlePopoverClose = this.handlePopoverClose.bind(this);
    this.handleSlidingMenuOpen = this.handleSlidingMenuOpen.bind(this);
    this.handleSlidingMenuClose = this.handleSlidingMenuClose.bind(this);
    this.hideWalletPopover = this.hideWalletPopover.bind(this);
    this.walletNotifCache = new BrowserStorage('WALLET_NOTIF_POPOVER', {
      persist: true
    });
    this.state = {
      showPopoverMenu: false,
      showSlidingMenu: false,
      showWalletPopover: this.walletNotifCache.getItem()?.show || null
    };
  }
  handleSignInClick(e) {
    this.props.onLogIn(e);
    this.props.onSignIn(e);
  }

  // for Desktop Popover menu
  handlePopoverOpen(e) {
    if (e.key === 'Enter' || e.type === 'click') {
      if (!this.props.isLoggedIn) {
        this.handleSignInClick(e);
        this.setState({
          showPopoverMenu: false
        });
      } else if (this.props.isLoggedIn && !this.state.showPopoverMenu) {
        this.props.onHeaderToggle(e, {
          open: true
        });
        this.setState({
          showPopoverMenu: true
        });
      }
    }
  }
  handlePopoverClose() {
    this.setState({
      showPopoverMenu: false
    });
  }

  // for Mobile/Tablet sliding menu
  handleSlidingMenuOpen(e) {
    if (!this.props.isLoggedIn) {
      this.handleSignInClick(e);
    } else {
      this.props.onHeaderToggle(e, {
        open: true
      });
      this.setState({
        showSlidingMenu: true
      });
      // disable scroll on document body while sliding menu is open
      document?.body?.classList?.add('sliding-menu-open');
    }
  }
  handleSlidingMenuClose(e) {
    this.props.onHeaderToggle(e, {
      open: false
    });
    this.setState({
      showSlidingMenu: false
    });
    // enable scroll on document body when menu is closed
    document?.body?.classList?.remove('sliding-menu-open');
  }
  hideWalletPopover() {
    this.walletNotifCache.setItem({
      ...this.walletNotifCache.getItem(),
      show: false
    });
    this.setState({
      showWalletPopover: false
    });
  }
  renderHeaderMenu() {
    const {
      navItems = {},
      onQuickSaveCountClick = () => {},
      showMessages = false,
      showMyCars = false,
      savedInventoryCount = 0,
      savedSearchCount = 0,
      onMessagesClick = () => {},
      onSavedSearchesClick = () => {},
      onMyCarsClick = () => {},
      onManageMyAdClick = () => {},
      onProfileClick = () => {},
      isTredEnable = false,
      psxNotificationsCount = 0,
      myCarsCount = 0,
      profile
    } = this.props;
    function getHeaderMenuItems() {
      const {
        editMyAdCTA,
        viewMessagesCTA,
        dashboardCTA,
        carsCTA,
        mySearchesCTA,
        privateSellerCTA,
        myCarsCTA,
        settings
      } = navItems;
      const onPrivateSellerItemClick = e => {
        onMessagesClick(e, {
          ...privateSellerCTA,
          destinationPage: 'psx_dashboard'
        });
      };
      const onDashboardItemClick = e => {
        onMessagesClick(e, {
          ...dashboardCTA,
          destinationPage: 'my_account'
        });
      };
      const onSavedInventoryItemClick = e => {
        onQuickSaveCountClick(e, {
          ...carsCTA,
          destinationPage: 'my_cars'
        });
      };
      const onSavedSearchItemClick = e => {
        onSavedSearchesClick(e, {
          ...mySearchesCTA,
          destinationPage: 'my_searches'
        });
      };
      const onMyCarsItemClick = e => {
        onMyCarsClick(e, {
          ...myCarsCTA,
          destinationPage: 'cars_i_own'
        });
      };
      const onMessagesItemClick = e => {
        onMessagesClick(e, {
          ...viewMessagesCTA,
          destinationPage: 'psx_dashboard'
        });
        if (isTredEnable) {
          window.open(`${global.location.origin}/marketplace/notifications`, '_blank');
        }
      };
      const onEditMyAdItemClick = e => {
        onManageMyAdClick(e, {
          ...editMyAdCTA,
          destinationPage: 'manage_syc'
        });
      };
      const onProfileItemClick = e => {
        onProfileClick(e, {
          ...settings,
          destinationPage: 'my_profile'
        });
      };
      const carsCTAlabelWithCount = `${carsCTA.label}  (${savedInventoryCount})`;
      const mySearchesCTAlabelWithCount = `${mySearchesCTA.label} (${savedSearchCount})`;
      const myCarsCTAlabelWithCount = `${myCarsCTA.label} (${myCarsCount})`;
      const viewMessagesCTAWithCount = `${viewMessagesCTA.label} (${psxNotificationsCount})`;
      return [{
        label: dashboardCTA.label,
        navProps: dashboardCTA,
        onClick: onDashboardItemClick,
        showCount: false,
        glyph: 'gauge',
        eventKey: 0,
        href: dashboardCTA.href
      }, {
        label: `${savedInventoryCount > 0 ? carsCTAlabelWithCount : carsCTA.label}`,
        count: savedInventoryCount,
        onClick: onSavedInventoryItemClick,
        navProps: carsCTA,
        glyph: 'saved-car',
        href: carsCTA.href,
        eventKey: 1
      }, {
        label: `${savedSearchCount > 0 ? mySearchesCTAlabelWithCount : mySearchesCTA.label}`,
        count: savedSearchCount,
        onClick: onSavedSearchItemClick,
        navProps: mySearchesCTA,
        glyph: 'search',
        href: mySearchesCTA.href,
        eventKey: 2
      }, ...(showMyCars ? [{
        classNames: clsx({
          disabled: myCarsCount === 0
        }),
        label: `${myCarsCount > 0 ? myCarsCTAlabelWithCount : myCarsCTA.label}`,
        count: myCarsCount,
        onClick: onMyCarsItemClick,
        navProps: myCarsCTA,
        glyph: 'cars',
        href: myCarsCTA.href,
        eventKey: 3
      }] : []), ...(showMessages ? [{
        glyph: 'checklist',
        onClick: onPrivateSellerItemClick,
        eventKey: 4,
        ...privateSellerCTA
      }] : []), ...(showMessages ? [{
        glyph: 'chat',
        onClick: onMessagesItemClick,
        href: viewMessagesCTA.href,
        label: parseInt(psxNotificationsCount, 10) > 0 ? viewMessagesCTAWithCount : viewMessagesCTA?.label,
        eventKey: 5
      }] : []), {
        glyph: 'edit',
        label: editMyAdCTA.label,
        onClick: onEditMyAdItemClick,
        ...editMyAdCTA,
        eventKey: 6
      }, {
        glyph: 'user-circle-regular',
        label: settings.label,
        onClick: onProfileItemClick,
        ...settings,
        eventKey: 7
      }];
    }
    const headerNavItems = getHeaderMenuItems();
    return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/_jsx(PopoverSheet, {
      role: "menu",
      id: "header-badge-popover-menu",
      "data-cmp": "headerBadgeDesktopNav",
      show: this.state.showPopoverMenu,
      onHide: this.handlePopoverClose,
      className: "popover-submenu",
      position: "center",
      containerElement: _div || (_div = /*#__PURE__*/_jsx("div", {})),
      popoverTriggerId: "userSignInCTA",
      useBottomSheet: false
    }, void 0, /*#__PURE__*/_jsx(PopoverHeader, {
      profile: profile,
      navItems: navItems,
      onLogOut: this.props.onLogOut,
      headerNavItems: headerNavItems
    })), /*#__PURE__*/_jsx(HeaderBadgeSlidingMenu, {
      navItems: headerNavItems,
      isSlidingMenuOpen: this.state.showSlidingMenu && this.props.isLoggedIn,
      handleSlidingMenuClose: this.handleSlidingMenuClose,
      isLoggedIn: this.props.isLoggedIn,
      onSignOutClick: this.props.onLogOut,
      profile: profile
    }));
  }
  renderWalletNotificationPopover() {
    const {
      onHeaderWalletPopoverClick = () => {},
      hasNewTradeIn,
      valuationHistory,
      dealNotifications,
      dealDetails = {},
      dealsDuck,
      paymentsDuck,
      showWalletAlertFlag
    } = this.props;
    const handleWalletPopoverClick = (e, options) => {
      onHeaderWalletPopoverClick(e, options);
      this.hideWalletPopover();
    };
    const cachedValuations = this.walletNotifCache.getItem()?.valuations || [];
    const dealNotifs = dealNotifications.total;
    const totalCachedDealNotifs = this.walletNotifCache.getItem()?.dealNotifs;

    // valuationHistory has a limit of 3 and overwrites FIFO
    const isNewValuations = valuationHistory !== null && (valuationHistory.length !== cachedValuations.length || valuationHistory[0]?.valuationDate !== cachedValuations[0]?.valuationDate);
    if (hasNewTradeIn && isNewValuations) {
      this.walletNotifCache.setItem({
        ...this.walletNotifCache.getItem(),
        valuations: valuationHistory,
        show: true
      });
    }
    if (!_isEmpty(dealNotifications)) {
      if (!totalCachedDealNotifs && dealNotifs || dealNotifs > totalCachedDealNotifs) {
        this.walletNotifCache.setItem({
          ...this.walletNotifCache.getItem(),
          dealNotifs,
          show: true
        });
      } else if (dealNotifs < totalCachedDealNotifs) {
        this.walletNotifCache.setItem({
          ...this.walletNotifCache.getItem(),
          dealNotifs
        });
      }
    }
    if (this.triggerDealReminder()) {
      this.walletNotifCache.setItem({
        ...this.walletNotifCache.getItem(),
        show: true
      });
    }
    const showPopover = (this.state.showWalletPopover !== null ? this.state.showWalletPopover : this.walletNotifCache.getItem()?.show) && !showWalletAlertFlag;
    return showPopover && /*#__PURE__*/_jsx(WalletHeaderPopover, {
      onClick: handleWalletPopoverClick,
      onCloseClick: this.hideWalletPopover,
      hasNewTradeIn: hasNewTradeIn,
      dealNotifications: dealNotifications,
      dealDetails: dealDetails,
      dealsDuck: dealsDuck,
      paymentsDuck: paymentsDuck,
      uiContext: "toast",
      position: "bottom"
    });
  }
  render() {
    const {
      className,
      showWallet = false,
      onWalletTrigger = () => {},
      hasNewTradeIn,
      numCreditAppDeals,
      dealNotifications,
      enableActiveDeals,
      isLoggedIn = false,
      profile = {},
      psxNotificationsCount = '0',
      onTriggerMouseEnter
    } = this.props;
    const handleWalletTrigger = e => {
      onWalletTrigger(e);
      this.hideWalletPopover();
    };
    return /*#__PURE__*/_jsx("div", {
      className: clsx('display-inline-block header-badge', className),
      "data-cmp": "myatc-headerbadge"
    }, void 0, /*#__PURE__*/_jsx("span", {
      className: "display-flex align-items-center"
    }, void 0, showWallet && /*#__PURE__*/_jsx(WalletHeaderBadge, {
      onWalletTrigger: handleWalletTrigger,
      hasNewTradeIn: hasNewTradeIn,
      numCreditAppDeals: numCreditAppDeals,
      dealNotifications: dealNotifications,
      dealReminderOn: this.triggerDealReminder()
    }), /*#__PURE__*/_jsx("div", {
      className: "display-none display-lg-block"
    }, void 0, /*#__PURE__*/React.createElement(HeaderBadgeTrigger, {
      isLoggedIn: isLoggedIn,
      profile: profile,
      psxNotificationsCount: psxNotificationsCount,
      onTriggerMouseEnter: onTriggerMouseEnter,
      onToggle: this.handlePopoverOpen,
      key: "header-badge-trigger",
      ref: this.triggerRef
    })), /*#__PURE__*/_jsx("div", {
      className: "display-block display-lg-none"
    }, void 0, /*#__PURE__*/React.createElement(HeaderBadgeTrigger, {
      isLoggedIn: isLoggedIn,
      profile: profile,
      psxNotificationsCount: psxNotificationsCount,
      onTriggerMouseEnter: onTriggerMouseEnter,
      onToggle: this.handleSlidingMenuOpen,
      key: "header-badge-trigger",
      ref: this.triggerRef
    }))), this.props.isLoggedIn && this.renderHeaderMenu(), showWallet && enableActiveDeals && this.renderWalletNotificationPopover());
  }
}
HeaderBadge.defaultProps = {
  isLoggedIn: false,
  showMessages: false,
  showMyCars: true,
  isTredEnable: false,
  showWallet: false,
  savedInventoryCount: 0,
  savedSearchCount: 0,
  myCarsCount: 0,
  onQuickSaveCountClick: () => {},
  onLogIn: () => {},
  onLogOut: () => {},
  onTriggerMouseEnter: () => {},
  onMessagesClick: () => {},
  onWalletTrigger: () => {},
  onSignUp: () => {},
  onSavedSearchesClick: () => {},
  onMyCarsClick: () => {},
  onManageMyAdClick: () => {},
  onProfileClick: () => {},
  onHeaderWalletPopoverClick: () => {},
  navItems: myatcNavItems,
  profile: {},
  hasNewTradeIn: false,
  valuationHistory: null,
  dealNotifications: {},
  enableActiveDeals: false,
  dealDetails: {},
  psxNotificationsCount: '0',
  onHeaderToggle: () => {}
};
export default HeaderBadge;